import type { TrainQuestionResult } from '../../../shared/results';

export type ActiveTrainQuestionResult = {
  level: number;
  question: number;
  startedAt: number;
  wrongHitCount: number;
  correctChoiceIndex: number;
  wrongChoiceIndices: number[];
};

export function beginTrainQuestionResult(
  level: number,
  question: number,
  startedAt: number,
  correctChoiceIndex = 0,
): ActiveTrainQuestionResult {
  return { level, question, startedAt, wrongHitCount: 0, correctChoiceIndex, wrongChoiceIndices: [] };
}

export function registerTrainWrongHit(active: ActiveTrainQuestionResult, choiceIndex = -1): ActiveTrainQuestionResult {
  const wrongChoiceIndices = choiceIndex >= 0 && !active.wrongChoiceIndices.includes(choiceIndex)
    ? [...active.wrongChoiceIndices, choiceIndex]
    : active.wrongChoiceIndices;
  return { ...active, wrongHitCount: active.wrongHitCount + 1, wrongChoiceIndices };
}

export function finishTrainQuestionResult(
  active: ActiveTrainQuestionResult,
  finishedAt: number,
  completed: boolean,
): TrainQuestionResult {
  return {
    level: active.level,
    question: active.question,
    durationMs: Math.max(0, Math.round(finishedAt - active.startedAt)),
    wrongHitCount: active.wrongHitCount,
    completed,
    correctChoiceIndex: active.correctChoiceIndex,
    wrongChoiceIndices: active.wrongChoiceIndices,
  };
}
